<template>
  <div class="w-3/4 mx-auto">
    <h1 class="text-xl mt-10 py-3 uppercase tracking-wider">
      {{ $t('teacher.students') }}
    </h1>
    <div class="flex flex-col w-full items-start mt-4">
      <round-photo-and-name
        v-for="student in students"
        :key="student.id"
        class="py-1 w-full"
        :person="student"
        textClass="pl-2"
        containerClass="items-center" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import RoundPhotoAndName from './graphics/RoundPhotoAndName.vue';

export default {
  components: { RoundPhotoAndName },
  data() {
    return {
      students: [],
    };
  },

  created() {
    this.getStudents();
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
      teacher: 'auth/teacher',
    }),
  },

  mixins: [StreamFunctionsMixin],

  methods: {
    getStudents() {
      axios.get(`/api/teachers/${this.$route.params.slug}/students`).then(({ data }) => {
        this.students = data;
      }).catch((error) => {
        console.log(error);
      });
    },

  },
};
</script>
